module.exports = __webpack_public_path__ + "static/fk_ebook_ikon-be00be3c5ede33519cedb42540b1dcbf.png";